import { App, fullRoutes } from "@songtradr-sso/shared/common";
import { Body, Button, Heading } from "@songtradr/design-language";
import { redirect } from "../../utils/navigation.utils";
import { Flex } from "../flex/Flex.Parts";
import { SongtradrGroupLogos } from "../songtradr-group-logos/SongtradrGroupLogos";
import { Container, LogoWrapper, Props, Spacer, text } from "./ErrorFlag.Parts";

export const ErrorFlag = ({ header, message }: Props) => (
  <Flex $justify="center" $align="center" $grow={0.5}>
    <Container>
      <LogoWrapper>
        <SongtradrGroupLogos />
      </LogoWrapper>
      <Spacer $height="8rem" />
      <Heading variant="h1">{header || text.defaultHeader}</Heading>
      <Spacer $height="1.5rem" />
      <Body variant="normal">{message || text.defaultMessage}</Body>
      <Spacer $height="3rem" />
      <Button
        $variant="important"
        onClick={() => redirect(fullRoutes[App.Core].signOut)}
      >
        {text.buttons.signOut}
      </Button>
    </Container>
  </Flex>
);
